import { useEffect } from "react";
import { useImmer } from "use-immer";

export const useAuthenticationScope = () => {
  const [auth, setAuth] = useImmer({
    isInitialLoad: true,
    data: {
      id: null,
      name: "",
      email: "",
      userType: null,
      token: "",
      stores: [],
      permissions: [],
      roles: [],
    },
    isSidebarOpen: true, // Adding isSidebarOpen to the object
  });

  useEffect(() => {
    setAuth((draft) => {
      draft.isInitialLoad = false;
    });
    const localStorageData = JSON.parse(
      localStorage.getItem("recipe-user-data")
    );
    if (localStorageData !== null) {
      setAuth((draft) => {
        draft.data = localStorageData;
        draft.isSidebarOpen = localStorageData.isSidebarOpen;
      });
    }
  }, [setAuth]);

  useEffect(() => {
    if (auth?.data?.id) {
      const data = {
        ...auth.data,
        isSidebarOpen: auth.isSidebarOpen,
      };
      localStorage.setItem("recipe-user-data", JSON.stringify(data));
    }
  }, [auth, auth.isSidebarOpen]);
  return { auth, setAuth };
};
